var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseButtonWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29.999994mm",
    height: "30mm",
    viewBox: "0 0 29.999994 30",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-5.0000068,-5.0000022)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#f9f9f9",
      strokeWidth: 1.85005
    },
    id: "rect434",
    width: 10.149949,
    height: 28.149946,
    x: 5.9250317,
    y: 5.9250317
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      stroke: "#f9f9f9",
      strokeWidth: 1.85005
    },
    id: "rect434-0",
    width: 10.149949,
    height: 28.149946,
    x: 23.925026,
    y: 5.9250274
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButtonWhite);
export default __webpack_public_path__ + "static/media/pause-button-white.0c8d4ed7f4f5e642062592d0d73e4d73.svg";
export { ForwardRef as ReactComponent };